import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGoalWinners } from "@/apps/goals/hooks/useGoalWinners";
import { formatWinnerReceivedDate } from "@/apps/goals/utils/formatTime";
import Skeleton from "@/ui/Skeleton/Skeleton";
import { useServiceT } from "@/utils/hooks/useServiceT";
import cls from "./styles.module.scss";

export const WinnersTicker = () => {
  const { t } = useTranslation();
  const serviceT = useServiceT();
  const { winners, isLoading } = useGoalWinners();
  const [now, setNow] = useState(() => Date.now());
  const shouldAnimate = winners.length >= 3;
  const tickerWinners = shouldAnimate ? [...winners, ...winners] : winners;

  const getAnimationDuration = () => {
    if (!shouldAnimate || tickerWinners.length === 0) return 0;

    const secondsPerItem = 1.5;
    const minDuration = 32;
    const calculatedDuration = tickerWinners.length * secondsPerItem;

    return Math.max(calculatedDuration, minDuration);
  };

  const animationDuration = getAnimationDuration();

  useEffect(() => {
    const intervalId = window.setInterval(() => setNow(Date.now()), 60 * 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  if (isLoading) {
    return (
      <div className={cls.root} aria-hidden="true">
        <div className={cls.trackSkeleton}>
          {Array.from({ length: 4 }).map((_, index) => (
            <div className={cls.card} key={index}>
              <Skeleton className={cls.skeletonRides} />
              <Skeleton className={cls.skeletonMeta} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (winners.length === 0) {
    return null;
  }

  return (
    <div
      className={shouldAnimate ? cls.root : cls.rootStatic}
      aria-label={t("goals.winners.ariaLabel")}
    >
      <div
        className={shouldAnimate ? cls.trackAnimated : cls.trackStatic}
        style={
          shouldAnimate
            ? {
                animationDuration: `${animationDuration}s`,
              }
            : undefined
        }
      >
        {tickerWinners.map((winner, index) => (
          <div
            className={cls.card}
            key={`${winner.driver_name}-${winner.received_date}-${index}`}
          >
            <div className={cls.rides}>
              🎯 {serviceT("goals.winners.rides", { count: winner.rides })}
            </div>
            <div className={cls.meta}>
              {winner.driver_name} ·{" "}
              {formatWinnerReceivedDate(winner.received_date, now)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
